import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { MediaModule, OutletModule, PageComponentModule } from '@spartacus/storefront';
import { CustomIconsModule } from '../../../../../custom/icons/custom-icons.module';
import { CustomTabParagraphContainerComponent } from './custom-tab-paragraph-container.component';

@NgModule({
  declarations: [CustomTabParagraphContainerComponent],
  imports: [
    CommonModule,
    PageComponentModule,
    OutletModule,
    I18nModule,
    MediaModule,
    BrowserModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CMSTabParagraphContainer: {
          component: CustomTabParagraphContainerComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomTabParagraphContainerModule { }
